export default from './search-results-list';



// WEBPACK FOOTER //
// ./app/containers/search-results-list/index.js